import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  private count = 0;
  private spinner$ = new BehaviorSubject<boolean>(false);

  constructor() {}

  getSpinnerObserver(): Observable<boolean> {
    return this.spinner$.asObservable();
  }

  requestStarted() {
    this.count++;
    this.spinner$.next(true);
  }

  requestEnded() {
    this.count -= 1;
    if (this.count === 0) {
      this.spinner$.next(false);
    }
  }
}
